"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;
/**
 * Checks whether or not a value is a boolean.
 *
 * @param {any} value evaluate if boolean
 * @returns {boolean} isBoolean
 */
function isBoolean(value) {
  return typeof value === 'boolean';
}